import { WorkRequirementIncomeScreen } from "@/interactors/WorkRequirementIncomeScreen";

export default function WorkRequirementIncome() {
  return <WorkRequirementIncomeScreen />;
}
